import { lazy } from "react";
import * as Sentry from "@sentry/react";

import { reloadOnceAfterChunkError, reloadPage } from "@/utils/chunkReload";

const SENTRY_FLUSH_MS = 1000;

const reportAndReload = (error: unknown) => () => {
  Sentry.captureException(error, { level: "warning", tags: { chunk_recovery: "reloaded" } });
  void Sentry.flush(SENTRY_FLUSH_MS)
    .catch(() => false)
    .then(() => reloadPage());
};

// Browsers keep a failed module import for the rest of the page's life, so calling the factory
// again would only repeat the failure: a reload is what downloads the chunk again.
export const lazyWithReload: typeof lazy = (factory) =>
  lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      if (!reloadOnceAfterChunkError(reportAndReload(error))) throw error;
      return new Promise<never>(() => {});
    }
  });
